module.exports = __webpack_public_path__ + "ae3893ae4b598b12396b1aa0d3b06d44.eot";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Italic.eot
// module id = 18
// module chunks = 0